<template>
	<div class="">
		<v-col cols="12" sm="12" class="">
			<v-data-table
				v-if="hasItens"
				:headers="colunas"
				:items="itens"
				:server-items-length="totalItens"
				item-key="id"
				:options="paginacaoInterna"
				no-data-text="Não há itens cadastrados"
				hide-default-footer
				class="arp-listview row-pointer"
			>
				<template #item.descricao="{ item }">
					<texto-tooltip
						:texto="item.descricao"
						:tamanho-maximo="textoTamanhoMaximo"
					></texto-tooltip>
				</template>
			</v-data-table>

			<template-listagem-vazia :total-itens="totalItens" :textos="textos"></template-listagem-vazia>

			<paginacao-tabela
				v-if="totalItens > 0"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:totalPaginas="totalPaginas"
				:totalItens="totalItens"
				@resetar-page="resetarPage"
			></paginacao-tabela>
		</v-col>
	</div>
</template>
<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'

export default {
	name: 'listagem-itens-ata-view',
	components: {},
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Tipo', 'tipo', '5%'),
				new TabelaColunaUtils('Seq', 'item', '5%'),
				new TabelaColunaUtils('Descrição', 'descricao', '40%'),
				new TabelaColunaUtils('Un. Aquis.', 'unidadeAquisicao', '10%'),
				new TabelaColunaUtils('Razão Social', 'fornecedor.razaoSocial', '20%'),
				new TabelaColunaUtils('Qtd.', 'estoqueAtual', '10%'),
				new TabelaColunaUtils('Valor Unitário', 'valorUnitario', '10%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontrados itens',
			},
			textoTamanhoMaximo: 80,
		}
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
	},
}
</script>
<style scoped lang="stylus"></style>
